"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChemSpectraClient = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _reduxSaga = _interopRequireDefault(require("redux-saga"));
var _index = _interopRequireDefault(require("./reducers/index"));
var _index2 = _interopRequireDefault(require("./sagas/index"));
var _frame = _interopRequireDefault(require("./frame"));
// import PropTypes from 'prop-types';
// import { logger } from 'redux-logger';

// - - - store & middleware - - -
const sagaMiddleware = (0, _reduxSaga.default)();
const middlewares = [sagaMiddleware]; // logger

const store = (0, _redux.compose)((0, _redux.applyMiddleware)(...middlewares))(_redux.createStore)(_index.default);
sagaMiddleware.run(_index2.default);

// - - - React - - -
const ChemSpectraClient = _ref => {
  let {
    editorOnly
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: store
  }, /*#__PURE__*/_react.default.createElement(_frame.default, {
    editorOnly: editorOnly
  }));
};
exports.ChemSpectraClient = ChemSpectraClient;
ChemSpectraClient.propTypes = {
  editorOnly: _propTypes.default.bool
};
ChemSpectraClient.defaultProps = {
  editorOnly: false
};

// eslint-disable-line